import store from "../../store/store";
import TimeStamp from "../timeStamp";
import FirebaseRead from "@/services/database/firebaseRead";
//import TimeStamp from "../timeStamp";

export default class SpielService  {
    static getTableHeader(vuetify, actions){
        let headerFix = vuetify.breakpoint.xsOnly ?
            [   { text: 'Spieltermin', value: 'termin'},
                { text: 'Liga', value: 'liga'},
                //{ text: 'Saison', value: 'saisonText'},
                { text: 'Runde', value: 'rundeGroup'},
                { text: 'Heimteam', value: 'heimTeam', align: 'right', sortable: false},
                { text: 'Gastteam', value: 'gastTeam', sortable: true},
                { text: 'Ergebnis', value: 'ergebnis', sortable: true},
                { text: 'Schnitt', value: 'schnitt', sortable: true},
            ] : [
                { text: 'Spieltermin', value: 'termin'},
                { text: 'Liga', value: 'liga'},
                //{ text: 'Saison', value: 'saisonText'},
                { text: 'Runde', value: 'rundeGroup'},
                { text: 'Heimteam', value: 'heimTeam', align: 'right', sortable: true},
                { text: '', value: 'vs', align: 'center', sortable: false},
                { text: 'Gastteam', value: 'gastTeam', sortable: true},
                { text: 'Ergebnis', value: 'ergebnis', sortable: true},
                { text: 'Schnitt', value: 'schnitt', sortable: true},
            ];
        headerFix.push({ text: 'Aktionen', value: 'actions', sortable: false, align: 'center' });
        return headerFix.concat(actions);
    }
    static async setSpieleList(spieleRaw){
        let list = [];
        for ( let i = 0; i < spieleRaw.length; i++ ) {
            const spiel = spieleRaw[i]
            const spielFull = await SpielService.setSpiel(spiel);
            list.push(spielFull);
        }
        list.sort((a, b) => a.rundeGroup > b.rundeGroup ? 1 : -1);
        return list;
    }

    static async setSpiel(spiel){
        const saison = spiel.saison.id.split('_');
        const ligaId = saison[0] + "_" + saison[1];
        //spiel.saisonText = saison[2] + "/" + saison[3];
        //spiel.termin = TimeStamp.getStringDotDateFromString(spiel.infos.datum)  + ' ' + spiel.infos.uhrzeit;
        spiel.termin = spiel.infos.datum + ' ' + spiel.infos.uhrzeit;
        if ( !store.state.realtime.landesverbaende[spiel.saison.lvId] ) {
            const landesVerband = await FirebaseRead.readSingleDoc('landesverbaende', spiel.saison.lvId)
            spiel.liga = landesVerband.ligen[ligaId].nameFull;
        } else {
            spiel.liga = store.state.realtime.landesverbaende[spiel.saison.lvId].ligen[ligaId].nameFull;
        }
        spiel.rundeGroup = spiel.saison.rundeText ? spiel.saison.rundeText :  spiel.saison.semester === 'A' ? spiel.saison.runde : spiel.saison.runde + ' ' + spiel.saison.semester;
        spiel.heimTeam = spiel.heim.teamName;
        spiel.gastTeam = spiel.gast.teamName;
        spiel.vs = ':';
        /*spiel.ts = spiel.vereine && spiel.vereine.confirmDeadline ?
                        spiel.vereine.confirmDeadline : '';*/
        //spiel.status = spiel.heim.result.kegel > 0 || spiel.gast.result.kegel > 0 ? 'Spiel läuft' : 'geplant';
        spiel.status = SpielService.getSpielStatusText(spiel).text;
        spiel.ergebnis = spiel.saison.isCup ?
                        spiel.heim.result.kegel + spiel.gast.result.kegel > 0 ?
                        spiel.heim.result.kegel + ' : ' + spiel.gast.result.kegel : '-' :
                        spiel.heim.result.mp + spiel.gast.result.mp > 0 ?
                        spiel.heim.result.mp + ' : ' + spiel.gast.result.mp : '-';
        spiel.schnitt = spiel.heim.result.schnitt + spiel.gast.result.schnitt > 0 ?
                        spiel.heim.result.schnitt + ' : ' + spiel.gast.result.schnitt : '-';
        spiel.heim.result.spielerRecord = SpielService.getSpielerRecordForTeam(spiel, 'heim');
        spiel.gast.result.spielerRecord = SpielService.getSpielerRecordForTeam(spiel, 'gast');
        spiel.winner = spiel.saison.isCup ? spiel.heim.result.cupLeader ? 'heim' : spiel.gast.result.cupLeader ? 'gast' : '' : ''
        return spiel;
    }

    static getExcerptForSaison(spiel){
        let data = JSON.parse(JSON.stringify(spiel));
        delete data.id;
        delete data.local;
        const heimSpielerRecord = SpielService.getSpielerRecordForTeam(spiel, 'heim');
        const gastSpielerRecord = SpielService.getSpielerRecordForTeam(spiel, 'gast');
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ACHTUNG: GANZ, GANZ WICHTIG !!!!
        // FÜR GEÄNDERTE SPIELE MUSS DAS AUCH AM SERVER GESETZT WERDEN !!!
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        data = {
            gast: {
                result: {
                    tabPkt: spiel.gast.result.tabPkt,
                    kegel: spiel.gast.result.kegel,
                    sp: spiel.gast.result.sp,
                    mp: spiel.gast.result.mp,
                    bR: spiel.gast.result.bR,
                    oeR: spiel.gast.result.oeR,
                    mR: spiel.gast.result.mR,
                    spielerRecord: gastSpielerRecord,
                },
                teamName: spiel.gast.teamName,
                teamId: spiel.gast.teamId,
            },
            heim: {
                result: {
                    tabPkt: spiel.heim.result.tabPkt,
                    kegel: spiel.heim.result.kegel,
                    sp: spiel.heim.result.sp,
                    mp: spiel.heim.result.mp,
                    bR: spiel.heim.result.bR,
                    oeR: spiel.heim.result.oeR,
                    mR: spiel.heim.result.mR,
                    spielerRecord: heimSpielerRecord,
                },
                teamName: spiel.heim.teamName,
                teamId: spiel.heim.teamId,
            },
            infos: {
                datum:  spiel.infos.datum,
                uhrzeit:  spiel.infos.uhrzeit,
                wochentag:  spiel.infos.wochentag,
                ort:  spiel.infos.ort,
                bahn:  spiel.infos.bahn,
                stream:  spiel.infos.stream,
            },
            saison: spiel.saison,
            referee: { name: spiel.referee.name },
            vereine: {
                heim: spiel.vereine.heim,
                gast: spiel.vereine.gast,
            }
        };
        return data;
    }
        static getSpielerRecordForTeam(spiel, type){
            const l = Object.keys(spiel.partien).length;
            for ( let i = 0; i < l; i++ ) {
                let partieId = i+1;
                if ( spiel.partien[partieId][type].oeR ||
                    spiel.partien[partieId][type].bR  ) {
                    return true;
                }
            }
            return false;
        }

    static getAltersklasse(akHJ, akJahr, saisonId, sportart){
    // WICHTIG: AUCH IN CLOUD FUNCTIONS aktuell halten
        if ( !akJahr ) { return '' }
        const sportJahr = saisonId.split('_'); // 1_1_2021_2022
        const firstYear = sportJahr[2];
        const secondYear = sportJahr[3];
    // step 1 calulcate achieved age in Sportjahr
        let age = 0;
        if ( akHJ === 1 ) {
            age = secondYear - akJahr
        } else if ( akHJ === 2 ) {
            age = firstYear - akJahr
        }
    // return class
        if ( sportart === 'bowling' ) {
            if ( age <= 12 ) {
                return 'U12'
            } else if ( age <= 15 ) {
                return 'U15'
            } else if ( age <= 19 ) {
                return 'U19'
            } else if ( age <= 23 ) {
                return 'U23'
            } else if ( age <= 50 ) {
                return 'AK' // allgemeine Klasse
            } else if ( age <= 57 ) {
                return 'Ü50'
            } else if ( age <= 64 ) {
                return 'Ü57'
            } else {
                return 'Ü64'
            }
        } else { // classic
            if ( age <= 10 ) {
                return 'U10'
            } else if ( age <= 15 ) {
                return 'U15'
            } else if ( age <= 19 ) {
                return 'U19'
            } else if ( age <= 23 ) {
                return 'U23'
            } else if ( age <= 50 ) {
                return 'AK' // allgemeine Klasse
            } else if ( age <= 60 ) {
                return 'Ü50'
            } else {
                return 'Ü60'
            }
        }
    }

    static getSpielStatusText(spiel){
        const isPending = spiel.vereine.heim.indexOf('pending') !== -1;
        let status = {};
        if ( isPending && !spiel.referee.name ) {
            status = {text: 'geplant', delayed: null, class: 'grey--text' };
        } else if ( isPending && spiel.infos.stream )  {
            status = {text: 'Spiel läuft', delayed: null, class: 'blue--text' };
        } else if ( isPending && spiel.heim.result.kegel + spiel.gast.result.kegel === 0 ) {
            status = {text: 'vor Spielbeginn', delayed: null, class: 'grey--text text--darken-1' };
        } else if ( isPending )  {
            status = {text: 'Spiel läuft', delayed: null, class: 'blue--text' };
        } else if ( spiel.vereine.heim.indexOf('created') !== -1 ) {
            status = {text: 'unbestätigt', delayed: null, class: 'warning--text', completed: true };
        } else if ( spiel.vereine.gast.indexOf('confirmed') !== -1 ) {
            status = {text: 'bestätigt', delayed: null, class: 'success--text', completed: true };
        } else if ( spiel.vereine.gast.indexOf('rejected') !== -1 ) {
            status = {text: 'abgelehnt', delayed: null, class: 'error--text', completed: true };
        } else if ( spiel.vereine.gast.indexOf('adminVerified') !== -1 ) {
            status = {text: 'strafverifiziert', delayed: null, class: 'error--text', completed: true };
        } else {
            status = {text: 'Fehler', class: 'error--text' };
        }
        status.delayed = SpielService.checkForDelay(spiel);
        if ( status.delayed ) {
            status.text += ' (verspätet)'; // necessary for list filtering
        }
        if ( spiel.infos.kommentar || spiel.infos.kommentarStrafe ) {
            status.text += '(kommentiert)'; // necessary for list filtering
        }
        /*let delayObject = SpielService.checkForDelay(spiel);
        if ( delayObject.delayed ) {
            status.text += ' (verspätet)';
            status.delayed = true;
            status.delta = delayObject.delta;
        }*/
        return status;
    }
    static isLiveGame(spiel) {
        const isPending = spiel.vereine.heim.indexOf('pending') !== -1;
        if ( isPending && !spiel.referee.name ) {
            return false;
        } else if ( isPending && spiel.heim.result.kegel + spiel.gast.result.kegel === 0 &&
                    !spiel.infos.stream) {
            return false;
        } else if ( isPending )  {
            return true;
        }
        return false;
    }
    static checkForDelay(spiel){
        //console.log ("-----------------------");
        const fristen = SpielService.getFristen(spiel.saison.id);
        const datePlannedText = spiel.infos.datum;
        const timePlannedText = spiel.infos.uhrzeit + ':00';
        const timeStampPlanned = TimeStamp.getGMTTimestampForTextDate(datePlannedText + ' ' + timePlannedText);
        const timeStampEndGast = timeStampPlanned + (fristen.gast * 60 * 60 * 1000);
        const timeStampEndHeim = timeStampPlanned + (fristen.heim * 60 * 60 * 1000);
        //const targetText = TimeStamp.getLocalDateAndTime(timeStampEndGast, true);
        /*console.log ("datePlannedText", datePlannedText );
        console.log ("datePlannedText", timePlannedText );
        console.log ("timeStampPlanned", timeStampPlanned );
        console.log ("timeStampEndGast", timeStampEndGast );
        console.log ("targetText", targetText );
        console.log ("vereine", spiel.vereine );*/
        const delayedGast = spiel.vereine.confirmedGast > timeStampEndGast;
        const delayedHeim = spiel.vereine.confirmedHeim > timeStampEndHeim;
    // return null if no delay
        if ( !delayedGast && !delayedHeim ) { return null; }
    // return object with details
        let reply = {
            delayedGast: delayedGast,
            delayedHeim: delayedHeim,
        };
        if ( reply.delayedGast ) {
            reply.deltaGast = TimeStamp.getTimeStampDeltaInHours(spiel.vereine.confirmedGast - timeStampEndGast)//'48h35'
        }
        if ( reply.delayedHeim ) {
            reply.deltaHeim = TimeStamp.getTimeStampDeltaInHours(spiel.vereine.confirmedHeim - timeStampEndHeim)//'48h35'
        }
        return reply;
    }
        static getFristen(saisonId){
            const fristen = store.state.snapshots.bestaetigungsfristen;
            if ( fristen ) {
                const frist = fristen.find(frist => frist.id === saisonId);
                if ( frist ) {
                    return frist;
                }
            }
            return {heim: 24, gast: 48}
        }


    static getLvIdFromVereinsNrLong(vereinsNrLong){
        if ( vereinsNrLong.length === 4 ) {
            return vereinsNrLong.substr(0,1)
        } else if ( vereinsNrLong.length === 5 ) {
            return vereinsNrLong.substr(0,2)
        } else {
            return '';
        }
    }

    static getVereinsNrFromVereinsNrLong(vereinsNrLong){
        if ( vereinsNrLong.length === 4 ) {
            return vereinsNrLong.substr(1)
        } else if ( vereinsNrLong.length === 5 ) {
            return vereinsNrLong.substr(2)
        } else {
            return '';
        }
    }
// admin actions
    static adminEmptyMaL(fullSpiel){
        console.log ("adminEmptyMaL", fullSpiel);
    // reset partien (= spieler)
        fullSpiel = SpielService.resetSpielerMal(fullSpiel);
    // reset teams (= ersatzspieler, captain)
        fullSpiel = SpielService.resetMalTeam(fullSpiel, 'heim');
        fullSpiel = SpielService.resetMalTeam(fullSpiel, 'gast');
    // reset Referee
        fullSpiel.referee = {lvId: '', name: '', nr: ''};
        if ( fullSpiel.saison.freieSpieler ) { fullSpiel.saison.datenschutz = false; }
    // reset Datenschutz
        return {
            gast: fullSpiel.gast,
            heim: fullSpiel.heim,
            partien: fullSpiel.partien,
            referee: fullSpiel.referee,
            saison: fullSpiel.saison,
            ['infos.stream']: '',
        };
    }
        static resetSpielerMal(fullSpiel){
            Object.keys(fullSpiel.partien).forEach( (partieId) => {
                let partie = fullSpiel.partien[partieId];
                fullSpiel.partien[partieId] = SpielService.resetSpielerMalTeam(partie, 'heim');
                fullSpiel.partien[partieId] = SpielService.resetSpielerMalTeam(partie, 'gast');
            });
            return fullSpiel;
        }
            static resetSpielerMalTeam(partie, type){
                partie[type].spieler.akHJ = '';
                partie[type].spieler.akJahr = '';
                partie[type].spieler.id = '';
                partie[type].spieler.name = '';
                partie[type].spieler.nationalitaet = '';
                partie[type].spieler.passNr = '';
                if ( partie[type].spieler.frei ) {
                    partie[type].spieler.frei = false;
                    partie[type].spieler.hatPass = false;
                    partie[type].spieler.vorname = '';
                    partie[type].spieler.nachname = '';
                }
                return partie;
            }
        static resetMalTeam(fullSpiel, type){
            // ersatzSpieler
                fullSpiel = SpielService.resetErsatzSpielerMaL(fullSpiel, type);
            // Kapitän
                fullSpiel[type].captain = '';
            //return
                return fullSpiel;
        }
            static resetErsatzSpielerMaL(fullSpiel, type){
                Object.keys(fullSpiel[type].ersatzSpieler).forEach( (spielerId) => {
                    let spieler = fullSpiel[type].ersatzSpieler[spielerId];
                    spieler.id = '';
                    spieler.name = '';
                    spieler.nationalitaet = '';
                    if ( spieler.akHJ ) {
                        spieler.akHJ = '';
                        spieler.akJahr = '';
                    }
                    if (spieler.frei){
                        spieler.frei = false;
                        spieler.hatPass = false;
                        spieler.nachname = '';
                        spieler.vorname = '';
                        spieler.passNr = '';
                    }
                });
                return fullSpiel
            }

    static adminEmptySpielbericht(fullSpiel){
    // reset Ersatzspieler
        fullSpiel = SpielService.resetErsatzSpieler(fullSpiel, 'heim');
        fullSpiel = SpielService.resetErsatzSpieler(fullSpiel, 'gast');
    // reset Kegel inputs in Partien
        fullSpiel = SpielService.resetPartien(fullSpiel);
    // reset team records
        fullSpiel = SpielService.resetTeamRecords(fullSpiel, 'heim');
        fullSpiel = SpielService.resetTeamRecords(fullSpiel, 'gast');
    // calculate result
        fullSpiel.calculate();
    // return update document as in regular process in editErgebnis
        return {
            gast: fullSpiel.gast,
            heim: fullSpiel.heim,
            partien: fullSpiel.partien,
            ['infos.kommentar']: '',
        };
    }
        static resetErsatzSpieler(fullSpiel, type){
            Object.keys(fullSpiel[type].ersatzSpieler).forEach( (spielerId) => {
                let spieler = fullSpiel[type].ersatzSpieler[spielerId];
                spieler.abWurf = 0;
                spieler.eintauschFuer = '';
                if (spieler.eintauschVorFuer){ spieler.eintauschVorFuer=''; }
            });
            return fullSpiel
        }
        static resetPartien(fullSpiel){
            Object.keys(fullSpiel.partien).forEach( (partieId) => {
                let partie = fullSpiel.partien[partieId];
                fullSpiel.partien[partieId] = SpielService.resetPartieByTeam(partie, 'heim');
                fullSpiel.partien[partieId] = SpielService.resetPartieByTeam(partie, 'gast');
            });
            return fullSpiel
        }
            static resetPartieByTeam(partie, type){
                partie[type].bR = false;
                partie[type].oeR = false;
                partie[type].fehlwuerfe = 0;
                partie[type].input = {d1: 0, d2: 0, d3: 0, d4: 0};
                if ( partie[type].inputAr ) partie[type].inputAr = {ar1: 0, ar2: 0, ar3: 0, ar4: 0};
                return partie;
            }
        static resetTeamRecords(fullSpiel, type){
            let teamResult = fullSpiel[type].result;
            teamResult.bR = false;
            teamResult.mR = false;
            teamResult.oeR = false;
            return fullSpiel
        }
    static adminCancelHeimConfirm(spiel){
        return {
            ['vereine.heim']: spiel.vereine.heim.replace('created', 'pending'),
            ['vereine.gast']: '',
        }
    }
    static adminCancelGastConfirm(spiel){
        return {
            ['vereine.alle']: [],
            ['vereine.heim']: spiel.vereine.heim.replace('confirmed', 'created'),
            ['vereine.gast']: spiel.vereine.gast.indexOf('confirmed') !== -1 ?
                        spiel.vereine.gast.replace('confirmed', 'waiting') :
                        spiel.vereine.gast.replace('rejected', 'waiting'),
        }
    }




}